import React from 'react';
import { useParams } from 'react-router-dom';
import BannerForDrop from '../../../components/collection/CollectionDetailsVideoForDrop';
import CollectionTabsForDrop from '../../../components/collection/CollectionTabsForDrop';

const CollectionDetailsDrop = () => {
    const { collectionAddress } = useParams();
 

    return (
        <div>
            <BannerForDrop collectionAddress={collectionAddress} />
            <div className="container">
                <CollectionTabsForDrop contractAddress={collectionAddress}  />
            </div>
        </div>
    )
}

export default CollectionDetailsDrop
